import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons/faCircleQuestion'

import useTranslation from '@space-core/hooks/useTranslation'
import { useSendDataHubModeration } from '@space-shell/common/hooks/useSendDataHubModeration'
import { useAuthStore, useMembershipStore } from '@space-shell/core/store'

import styled from 'styled-components'

import { FAQ_URL } from './constants'

import { SessionMode } from '../../baseStructure/enum'
import MenuItem from '../../baseStructure/menu/menuItem'

const CustomMenuItem = styled(MenuItem)`
  --hc-structure-menu-item-padding: var(--spacer-4);
  border-top: 0.063rem solid var(--component-border-color) !important;
  padding: 1rem 0 !important;
`

const FAQ = () => {
  const { t } = useTranslation()

  const { membershipData } = useMembershipStore()
  const { ucode, id } = useAuthStore()
  const { sendDatahubModerationClickFAQClub } = useSendDataHubModeration()

  const handleClickFAQ = () => {
    window.open(FAQ_URL, '_blank')

    sendDatahubModerationClickFAQClub({
      membershipSlug: membershipData?.slug as string,
      membershipId: membershipData?.id as string,
      ucode: ucode ? ucode : 'X',
      hasAccess: ucode ? true : false,
      userId: ucode ? Number(id) : 0
    })
  }

  return (
    <CustomMenuItem
      classNameSpan='_font-14 _py-4'
      label={t('menu.faq')}
      isActive={false}
      onClick={handleClickFAQ}
      iconPrimary={faCircleQuestion}
      color={String(membershipData?.settings?.primaryColor)}
      session={SessionMode.DEFAULT}
    />
  )
}

export default FAQ
